import Head from 'next/head';
import { useRouter } from 'next/router';
import { getSiteOrganizationSchema } from 'lib/seo/site-organization-schema';
import { SiteName } from 'lib/constants/brand-theme-site';
import { homePageUri } from 'lib/seo/constants';
import { Data } from '@generated/Foundation.GMI.model';

interface SiteSpecificOrganizationSchemaProps {
  siteName: SiteName;
  seoSettings: Data.Settings.SeoSettings;
}

/**
 * Renders site-specific Organization Schema markup in the head section
 * Only renders on the homepage for sites that have a custom organization schema
 */
export default function SiteSpecificOrganizationSchema({
  siteName,
  seoSettings,
}: SiteSpecificOrganizationSchemaProps) {
  const router = useRouter();
  const schema = getSiteOrganizationSchema(siteName, seoSettings);
  const currentPath = router.asPath?.split('?')[0] || ''; // Remove query params

  // Only render if:
  // 1. This site has a custom organization schema AND
  // 2. We are on the homepage (path is '/' or empty)
  if (!schema || (currentPath !== homePageUri && currentPath !== '')) {
    return null;
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
}
